(function () {
  function normalize(value) {
    return String(value || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function containsAny(text, terms) {
    return terms.some(function (term) { return text.indexOf(term) !== -1; });
  }

  function categoryMatches(filter, text) {
    var rules = {
      whatsapp: ['whatsapp', 'telefon', 'videoanruf', 'sprachnachricht', 'kontakte', 'nachrichten'],
      'fotos-videos': ['foto', 'fotos', 'bild', 'bilder', 'video'],
      navigation: ['google-navigation', 'google & navigation', 'google-maps', 'google maps', 'navigation', 'standort', 'route', 'bus', 'bahn'],
      'sicherheit-notfall': ['sicherheit', 'notruf', 'notfall', 'sos', 'fingerabdruck', 'bildschirm sperren', 'bildschirm-sperren', 'betrug', 'passwort'],
      'einstellungen-bedienung': ['grundlagen & einstellungen', 'grundlagen-einstellungen', 'einstellungen', 'bedienung', 'display', 'schrift', 'nachtmodus', 'bildschirm', 'lautstarke', 'tone'],
      'alltag-organisation': ['kalender', 'erinnerung', 'e-mail', 'email', 'wetter', 'alltag', 'organisation'],
      grundlagen: ['grundlagen & einstellungen', 'grundlagen-einstellungen', 'apps & play store', 'apps-play-store', 'grundlagen', 'einsteiger', 'wlan', 'google-konto', 'google konto', 'app installieren', 'apps installieren']
    };
    return rules[filter] ? containsAny(text, rules[filter]) : text.indexOf(filter) !== -1;
  }

  function debounce(callback, delay) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { callback.apply(context, args); }, delay);
    };
  }

  function updateFinder(finder, resetLimit) {
    if (!finder) return;
    if (resetLimit) finder.dataset.slVisibleLimit = finder.dataset.slInitialCount || '12';

    var activeFilterButton = finder.querySelector('[data-sl-filter].is-active');
    var activeFormatButton = finder.querySelector('[data-sl-format-filter].is-active');
    var activeFilter = activeFilterButton ? normalize(activeFilterButton.dataset.slFilter) : 'all';
    var activeFormat = activeFormatButton ? normalize(activeFormatButton.dataset.slFormatFilter) : 'all';
    var input = finder.querySelector('[data-sl-search-input]');
    var query = normalize(input ? input.value : '');
    var cards = Array.prototype.slice.call(finder.querySelectorAll('[data-sl-card]'));
    var limit = parseInt(finder.dataset.slVisibleLimit || finder.dataset.slInitialCount || '12', 10);
    var matches = [];

    cards.forEach(function (card) {
      var tags = normalize(card.dataset.slTags);
      var category = normalize(card.dataset.slCategory);
      var searchText = normalize(card.dataset.slSearchText);
      var format = normalize(card.dataset.slFormat) || 'ebook';
      var haystack = [tags, category, searchText].join(' ');
      var formatOk = activeFormat === 'all' || format === activeFormat;
      var filterOk = activeFilter === 'all' || categoryMatches(activeFilter, haystack);
      var searchOk = query === '' || searchText.indexOf(query) !== -1;
      if (formatOk && filterOk && searchOk) matches.push(card);
    });

    cards.forEach(function (card) {
      card.classList.add('sl-is-hidden');
      card.setAttribute('aria-hidden', 'true');
    });

    matches.slice(0, limit).forEach(function (card) {
      card.classList.remove('sl-is-hidden');
      card.setAttribute('aria-hidden', 'false');
    });

    var empty = finder.querySelector('[data-sl-empty]');
    if (empty) {
      empty.classList.toggle('sl-is-hidden', matches.length !== 0);
      empty.setAttribute('aria-hidden', matches.length === 0 ? 'false' : 'true');
    }

    var count = finder.querySelector('[data-sl-count]');
    if (count) count.textContent = matches.length + ' Ratgeber gefunden';

    var loadMore = finder.querySelector('[data-sl-load-more]');
    if (loadMore) {
      loadMore.classList.toggle('sl-is-hidden', matches.length <= limit);
      loadMore.setAttribute('aria-hidden', matches.length <= limit ? 'true' : 'false');
    }
  }

  function initFinder(finder) {
    if (!finder || finder.dataset.slInitialized === 'true') return;
    finder.dataset.slInitialized = 'true';
    finder.dataset.slVisibleLimit = finder.dataset.slInitialCount || '12';

    var debouncedSearch = debounce(function () { updateFinder(finder, true); }, 200);
    var input = finder.querySelector('[data-sl-search-input]');
    if (input) input.addEventListener('input', debouncedSearch);

    finder.addEventListener('click', function (event) {
      var filter = event.target.closest('[data-sl-filter]');
      var format = event.target.closest('[data-sl-format-filter]');
      var loadMore = event.target.closest('[data-sl-load-more]');

      if (filter) {
        finder.querySelectorAll('[data-sl-filter]').forEach(function (button) {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        });
        filter.classList.add('is-active');
        filter.setAttribute('aria-pressed', 'true');
        updateFinder(finder, true);
      }

      if (format) {
        finder.querySelectorAll('[data-sl-format-filter]').forEach(function (button) {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        });
        format.classList.add('is-active');
        format.setAttribute('aria-pressed', 'true');
        updateFinder(finder, true);
      }

      if (loadMore) {
        finder.dataset.slVisibleLimit = String(parseInt(finder.dataset.slVisibleLimit || '12', 10) + parseInt(finder.dataset.slLoadMoreCount || '12', 10));
        updateFinder(finder, false);
      }
    });

    updateFinder(finder, false);
  }

  function initAll() {
    document.querySelectorAll('[data-sl-product-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFinder(event.target.querySelector('[data-sl-product-finder]'));
  });
})();
